export const residentialWasteRecyclingPickUpDataFr = [
  {
    Question: `Quand le camion à ordures vient-il pour la collecte dans mon quartier?`,
    Answer: `Le jour et l'heure de la collecte des ordures dans votre région dépendront d'un certain nombre de facteurs. En tant que client WM, vous pouvez facilement accéder à votre horaire de collecte et consulter l'heure d'arrivée prévue de votre camion dans votre compte My WM.`,
  },
  {
    Question: `Quand dois-je sortir mes bacs ou mes bennes pour la collecte hebdomadaire en bordure de rue?`,
    Answer: `Apportez vos bacs vers la rue et placez-les en bordure avant 6 heures du matin le jour de votre collecte. Ne surchargez pas les bacs. Les couvercles doivent être complètement fermés. Des frais d'excédent peuvent s'appliquer lorsque les bacs sont trop remplis. Assurez-vous que tous les détritus et débris sont à l'intérieur du bac. Les ordures ou déchets laissés à côté des bacs pourraient ne pas être ramassés.`,
  },
  {
    Question: `Quels articles puis-je mettre dans les ordures?`,
    Answer: `Les articles suivants font partie des ordures de tous les jours. Ces articles peuvent être placés dans vos caissettes, bacs, bennes ou conteneurs de bordure de rue.
     <ul>
     <li>Couches</li>
     <li>Rasoirs jetables</li>
     <li>Branches de cactus et de palmiers</li>
     <li>Litière pour chat et excréments d'animaux</li>
     <li>Verres et plats/tasses en céramique</li>
     <li>Tuyaux et câbles</li>
     <li>Boîtes/sachets de jus</li>
     <li>Ampoules non fluorescentes</li>
     <li>Verre de vitres (fenêtres, miroirs, etc.)</li>
     <li>Gobelets et matériaux d'emballage en polystyrène</li>
     <li>Bois traité (peint, teint, etc.)</li>
     </ul>`,
  },
  {
    Question: `Quels articles ne peuvent pas aller dans les ordures?`,
    Answer: `Les déchets dangereux suivants ne devraient PAS être traités comme ordures ménagères et ne devraient PAS être placés dans vos caissettes, bacs ou bennes en bordure de rue :
     <ul>
     <li>Piles</li>
     <li>Produits électroniques</li>
     <li>Ampoules fluorescentes</li>
     <li>Peinture et pots de peinture</li>
     <li>Huiles et filtres de moteur usés</li>
     <li>Médicaments d'ordonnance</li>
     </ul>
     Waste Management possède des lieux de dépôt à travers le Canada et les États-Unis. Visitez l'un de ces emplacements pour vous débarrasser correctement de vos déchets ménagers dangereux susmentionnés.`,
  },
  {
    Question: `Quels sont les articles et matières recyclables?`,
    Answer: `Vérifiez notre page Recyclage 101 pour la liste de matières recyclables/non-recyclables, ainsi que des astuces et des renseignements pour recycler chez vous. À titre de référence rapide, les articles courants suivants doivent être recyclés, à la condition qu'ils soient propres et secs.
     <ul>
     <li>Bouteilles et canettes</li>
     <li>Papier</li>
     <li>Carton</li>
     </ul>`,
  },
  {
    Question: `Quels sont les articles et matières qui ne sont PAS recyclables?`,
    Answer: `Les matériaux non recyclables doivent être placés dans vos poubelles habituelles. Assurez-vous que vos poubelles, conteneurs, bennes ou bacs ne sont pas surchargés et que leurs couvercles peuvent être complètement fermés. Des frais supplémentaires peuvent s'appliquer pour les conteneurs trop remplis ou contaminés.

     En règle générale, les articles ci-dessous ne peuvent pas être recyclés par la collecte en bordure de rue. Pour en savoir plus sur les matières recyclables et non recyclables, consultez notre page Recyclage 101.
     <ul>
     <li>Sacs en plastique (ceux-ci peuvent souvent être retournés à une épicerie locale)</li>
     <li>Plats, tasses et verres en céramique</li>
     <li>Boîtes/sachets de jus</li>
     <li>Gobelets et matériaux d'emballage en polystyrène</li>
     <li>Verre de vitres (fenêtres, miroirs, etc.)</li>
     </ul>
     Waste Management possède des lieux de dépôt à travers le Canada et les États-Unis. Visitez l'un de ces emplacements pour éliminer les articles non recyclables volumineux ou encombrants de manière appropriée et responsable. Les objets encombrants sont ceux qui sont trop gros ou trop lourds pour votre poubelle ou votre bac habituels.`,
  },
  {
    Question: `Comment puis-je obtenir un nouveau conteneur, caissette ou bac Waste Management pour ma résidence?`,
    Answer: `Les clients de Waste Management peuvent entrer en relation avec nous par téléphone, courriel ou clavardage pour faire réparer ou remplacer un conteneur WM.`,
  },
  {
    Question: `Comment se débarrasser d'un matelas usagé ou d'une vieille toilette? Puis-je programmer une collecte d'encombrants?`,
    Answer: `Les ramassages d'« encombrants » et d'objets volumineux sont disponibles pour certains clients de Waste Management. Des modalités, frais et conditions peuvent s'appliquer. Les clients WM peuvent facilement programmer le ramassage d'encombrants à partir de leur compte My WM.

     Les articles considérés comme encombrants comprennent :
     <ul>
     <li>Électroménager, téléviseurs et appareils électroniques</li>
     <li>Mobilier de maison</li>
     <li>Déchets métalliques</li>
     <li>Pneus : jusqu'à 4 pneus de voiture ou de camionnette, séparés des jantes</li>
     <li>Déchets de jardin — bottés pour le compostage</li>
     </ul>
     Waste Management a un lieu de dépôt près de chez vous. Rendez-vous au lieu de dépôt le plus proche pour vous débarrasser correctement des articles volumineux ou encombrants qui sont trop gros ou trop lourds pour votre bac ou votre benne habituels`,
  },
]
